import store from '../store'
import ru from '../locales/ru.json'
import uk from '../locales/uk.json'

const locales = {
  'ru_RU': ru,
  'uk_UA': uk,
}

export default function localizeFilter(key){
  const locale = store.getters.locale || 'uk_UA'
  return locales[locale][key] || key
}